import React from "react";
import { IconType } from "../../type/icon_type";

const ChevronRight = (props: IconType) => {
  const { width, height, color, style, onClick } = props;
  return (
    <svg
      width={width || "24"}
      height={height || "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      onClick={onClick}
    >
      <path
        d="M9 18L15 12L9 6"
        stroke={color || "#73787E"}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const ChevronLeft = (props: IconType) => {
  const { width, height, color, style, onClick } = props;
  return (
    <svg
      width={width || "24"}
      height={height || "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      onClick={onClick}
    >
      <path
        d="M15 18L9 12L15 6"
        stroke={color || "#73787E"}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const ChevronDown = (props: IconType) => {
  const { width, height, color, style } = props;
  return (
    <svg
      width={width || "24"}
      height={height || "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M6 9L12 15L18 9"
        stroke={color || "#73787E"}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const ChevronDownBlack = (props: IconType) => {
  const { width, height, color, style } = props;
  return (
    <svg
      width={width || "20"}
      height={height || "20"}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path d="M5.5 7.5L10 13L14.5 7.5" fill="#464C52" />
      <path
        d="M5.5 7.5L10 13L14.5 7.5H5.5Z"
        stroke={color || "#464C52"}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const ChevronUp = (props: IconType) => {
  const { width, height, color, style } = props;
  return (
    <svg
      width={width || "24"}
      height={height || "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M18 15L12 9L6 15"
        stroke={color || "#73787E"}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export { ChevronRight, ChevronLeft, ChevronDown, ChevronDownBlack, ChevronUp };
